export default __webpack_public_path__ + "images/1840c493d9cb0aa4416dd7a9f7f1b9d2-PricingCalculator.svg";